import React from 'react';
import pointsIcon from '../assets/points_icon.png';
import Avatar from './Avatar';

export default function HistoryList({ data, isAdmin, onDelete, showRecipient = false }) {
  if (!data || data.length === 0) {
    return (
      <div className="history-container">
        <p style={{ textAlign: 'center', color: '#b9bbbe' }}>Нет записей, соответствующих вашим фильтрам.</p>
      </div>
    );
  }

  const handleDeleteClick = (entryId) => {
    if (window.confirm('Вы уверены, что хотите удалить эту запись? Это действие необратимо.')) {
      onDelete(entryId);
    }
  }

  return (
    <div className="history-container">
      <ul className="history-list">
        {data.map((entry) => {
          const isSeasonal = !!entry.seasonId;
          const isTransfer = entry.category === 'Перевод';
          const isOutgoingTransfer = isTransfer && entry.points < 0;

          return (
            <li key={entry.id} className="history-item card">
              {/* Блок для отображения получателя в общей истории */}
              {showRecipient && entry.recipient && (
                <div className="history-recipient-info">
                  <Avatar
                    user={{ ...entry.recipient, id: entry.recipientId }}
                    className="history-recipient-avatar"
                  />
                  <span>{entry.recipient.serverNickname || entry.recipient.username}</span>
                </div>
              )}

              <div className="history-item-content">
                {/* -- Верхняя часть карточки -- */}
                <div className="history-item-top">
                  <div className="history-points-group">
                    <span className={`history-points ${entry.points > 0 ? 'positive' : 'negative'}`}>
                      {entry.points > 0 ? `+${entry.points}` : entry.points}
                    </span>
                    <img
                      src={pointsIcon}
                      alt="points"
                      className={`points-icon ${isSeasonal ? 'seasonal-icon' : ''}`}
                      title={isSeasonal ? 'Сезонные очки' : 'Общие очки'}
                      style={{ marginTop: '2px' }}
                    />
                  </div>
                  <span className="history-category">{entry.category}</span>
                </div>

                {/* -- Средняя часть (причина) -- */}
                <p className="history-reason">{entry.reason || 'Без причины'}</p>

                {/* -- Нижняя часть (футер) -- */}
                <div className="history-item-bottom">
                  <div className="history-footer">
                    {isOutgoingTransfer ? (
                      <span>Кому: {entry.granterName}</span>
                    ) : (
                      <span>От: {entry.granterName}</span>
                    )}
                    <span>{new Date(entry.createdAt).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                  </div>

                  {/* Кнопка удаления (для админов, не для переводов) */}
                  {isAdmin && !isTransfer && (
                    <div className="history-item-actions">
                      <button
                        className="delete-entry-button"
                        title="Удалить запись"
                        onClick={() => handleDeleteClick(entry.id)}
                      >
                        &times;
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}